import React from 'react';
import styled from 'styled-components';
import {Link} from 'react-router-dom';


const Tile = ({title,children,link}) => {
  return (
    <TileWrapper to={link}>
      <TileTitle>{title}</TileTitle>
      {children}
    </TileWrapper>
  );
};

const TileWrapper = styled(Link)`
  display: block;
  color: #333;
  background: #fff;
  border-radius: 8px;
  padding 24px;
  text-align: center;
  box-shadow: 0 0px 5px 0px rgba(65,65,65,0.2);
  margin-bottom: 20px;

  :hover {
    color: #333;
    text-decoration: none;
  }
`;

const TileTitle = styled.div`
  font-size: 24px;
  margin-bottom: 20px;
`;

export default Tile;
